import { FC, MouseEvent, ReactNode } from 'react'
import { composeClasses } from '@/utils/compose-classes'
import { Button } from '@/components/buttons'
import { Divider } from '@/components/divider'
import { _ContainerDropdownFooter } from './ContainerDropdownFooter'

export interface DropdownFooterProps {
  children?: ReactNode
  onReset?: (event: MouseEvent) => void
  onConfirm?: (event: MouseEvent) => void
  resetLabel?: string
  confirmLabel?: string
  className?: string
  sizesButtons?: 'xsmall' | 'small' | 'medium'
  isDisabledReset?: boolean
  isDisabledConfirm?: boolean
  isLoadingReset?: boolean
  isLoadingConfirm?: boolean
}

export const _DropdownFooter: FC<DropdownFooterProps> = ({
  children,
  confirmLabel = 'Aceptar',
  onConfirm,
  onReset,
  resetLabel = 'Limpiar',
  className,
  sizesButtons = 'xsmall',
  isDisabledReset,
  isDisabledConfirm,
  isLoadingReset,
  isLoadingConfirm
}) => {
  if (children) {
    return (
      <_ContainerDropdownFooter className={className}>
        {children}
      </_ContainerDropdownFooter>
    )
  }

  return (
    <>
      <Divider />
      <_ContainerDropdownFooter
        className={composeClasses(
          className,
          'flex flex-row items-center justify-between gap-1'
        )}
      >
        <Button
          dataTestId="dropdown-reset-button"
          isLoading={isLoadingReset}
          isDisabled={isDisabledReset}
          size={sizesButtons}
          className="!px-0 !py-1"
          variant="link"
          onClick={onReset}
        >
          {resetLabel}
        </Button>
        <Button
          dataTestId="dropdown-confirm-button"
          isDisabled={isDisabledConfirm}
          isLoading={isLoadingConfirm}
          size={sizesButtons}
          variant="secondary"
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </_ContainerDropdownFooter>
    </>
  )
}
